import { ComparisonChartsPage, ComparisonChartsPageConfig } from '@app/components/page/ComparisonChartsPage'
import { BackofficeApiActions } from '@lib/Core/API/BackofficeApiActions'
import React from 'react'

const ComparisonChartsPageConfig: ComparisonChartsPageConfig = {
  tableName: 'formulation_analysis_table',
  getFiltersActionName: BackofficeApiActions.GetFormulationInsightsFilters,
  getDataActionName: BackofficeApiActions.GetFormulationInsightsData,
  pageTitle: 'Compare formulations',
  pageDescription: 'Apply filters and explore results to discover new opportunities.',
}

const FormulationAnalysisComparison: React.FunctionComponent = () => {
  return <ComparisonChartsPage {...ComparisonChartsPageConfig}></ComparisonChartsPage>
}

export { FormulationAnalysisComparison }
